<script>
    import LoadingSpinner from "../LoadingSpinner.svelte";

    import Select, {Option} from '@smui/select';
    import Icon from '@smui/select/icon/index';
    import HelperText from '@smui/select/helper-text/index';
    import Button, {Group, GroupItem, Label} from '@smui/button';

    export let options = {};
    export let text;
    export let value;
    export let style = "";
    export let disabled;
    export let fullwidth;
    export let variant = "raised";

    $: content = text || value;
</script>

<Button {variant} type="button" {fullwidth} on:click {disabled} {style} {...options}>
    {#if content}
        <Label>{content}</Label>
    {:else}
        <slot>
            <!-- yield content -->
        </slot>
    {/if}
</Button>